import { render, staticRenderFns } from "./TableName.vue?vue&type=template&id=2f456392&"
import script from "./TableName.vue?vue&type=script&lang=js&"
export * from "./TableName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports